// client/src/components/marketer/result/modals/ApproveCompleteModal.js
import React from 'react';
import '../../../../styles/marketer/modals/ResultApproveModals.css';

export default function ApproveCompleteModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="result-approve-modal mbm-overlay" onClick={onClose}>
      <div className="result-approve-modal__content mbm" onClick={(e) => e.stopPropagation()}>
        {/* 아이콘 */}
        <div className="result-approve-modal__complete-icon-container">
          <div className="result-approve-modal__complete-icon">✓</div>
        </div>

        {/* 제목 및 설명 */}
        <h2 className="result-approve-modal__complete-title mbm-title">결과물 승인 완료!</h2>
        <div className="result-approve-modal__complete-description">
          결과물이 성공적으로 승인되었습니다.
        </div>

        {/* 완료 정보 */}
        <div className="result-approve-modal__complete-info-box">
          <div className="result-approve-modal__complete-info-item">
            <div className="result-approve-modal__complete-info-icon">💰</div>
            <div>
              <div className="result-approve-modal__complete-info-title">보상 포인트 지급 완료</div>
              <div className="result-approve-modal__complete-info-desc">인플루언서에게 보상 포인트가 자동으로 지급되었습니다.</div>
            </div>
          </div>
          
          <div className="result-approve-modal__complete-info-item">
            <div className="result-approve-modal__complete-info-icon">📊</div>
            <div>
              <div className="result-approve-modal__complete-info-title">만족도 평가 반영</div>
              <div className="result-approve-modal__complete-info-desc">입력하신 만족도 점수가 인플루언서 성과 지표에 반영되었습니다.</div>
            </div>
          </div>
        </div>

        {/* 닫기 버튼 */}
        <div className="mbm-foot">
          <button onClick={onClose} className="result-approve-modal__complete-confirm-button mb-btn mb-btn-primary">
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

